import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
// import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Typography from '@material-ui/core/Typography';

import customInputStyle from "../../../assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx";

function MultilineCustomInput({ ...props }) {
  const {
    classes,
    formControlProps,
    labelText,
    id,
    // labelProps,
    inputProps,
    error,
    white,
    inputRootCustomClasses,
    success,
    helpText
  } = props;

  // const labelClasses = classNames({
  //   [" " + classes.labelRootError]: error,
  //   [" " + classes.labelRootSuccess]: success && !error
  // });
  // const underlineClasses = classNames({
  //   [classes.underlineError]: error,
  //   [classes.underlineSuccess]: success && !error,
  //   [classes.underline]: true,
  //   [classes.whiteUnderline]: white
  // });
  const marginTop = classNames({
    [inputRootCustomClasses]: inputRootCustomClasses !== undefined
  });
  const inputClasses = classNames({
    [classes.input]: true,
    [classes.whiteInput]: white,
  });
  var formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = classNames(
      formControlProps.className,
      classes.formControl
    );
  } else {
    formControlClasses = classes.formControl;
  }
  var helpTextClasses = classNames({
    [classes.labelRootError]: error,
    [classes.labelRootSuccess]: success && !error
  });
  return (
    <FormControl {...formControlProps} className={formControlClasses}>
      {labelText !== undefined ? (
        // <InputLabel
        //   className={classes.labelRoot + " " + labelClasses}
        //   htmlFor={id}
        //   {...labelProps}
        // >
        //   {labelText}
        // </InputLabel>
        <Typography
          className={classes.typography}> {labelText} </Typography>
      ) : null}
      <OutlinedInput
        multiline
        rows={6}
        labelWidth={0}
        classes={{
          input: inputClasses,
          root: marginTop,
          disabled: classes.disabled,
          // underline: underlineClasses
        }}
        style={{padding:'0'}}
        id={id}
        {...inputProps}
      />
      {helpText !== undefined ? (
        <FormHelperText id={id + "-text"} className={helpTextClasses} >
          {helpText}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}

MultilineCustomInput.propTypes = {
  classes: PropTypes.object.isRequired,
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  helpText: PropTypes.node
};

export default withStyles(customInputStyle)(MultilineCustomInput);
